import styled from 'styled-components';
import { getBackgroundColor, themeGet } from '@magalu/stereo-ui-styles';
import Grid from '../Grid';
export const Label = styled(Grid).attrs(props => Object.assign({
  forwardedAs: 'label',
  color: 'text.base',
  gridTemplateColumns: 'min-content auto',
  gridGap: 3,
  py: 3
}, props))`
  cursor: pointer;
  align-items: center;
`;
export const Input = styled.input.attrs(props => Object.assign({
  type: 'radio'
}, props))`
  pointer-events: ${({
  pointerNone
}) => pointerNone ? `none` : `auto`};
  appearance: none;
  background: transparent;
  width: 20px;
  height: 20px;
  border: ${themeGet('borders.1')};
  border-radius: ${themeGet('radii.circle')};
  cursor: pointer;

  &:checked {
    border-color: ${getBackgroundColor('primary')};

    &:before {
      content: '';
      display: block;
      position: relative;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 10px;
      height: 10px;
      border-radius: ${themeGet('radii.circle')};
      background: ${getBackgroundColor('primary')};
    }
  }
`;